import { BaseProviderInstanceModel } from './base-provider-instance-model';

export class RuleManagementAccessOperationModel extends BaseProviderInstanceModel {
  allResources: boolean;
  userIds: string[];
  resourceIds: string[];
  rebuildFromConfig: boolean;
}
